import { render, staticRenderFns } from "./CardCompareCurrentB2X.vue?vue&type=template&id=1444034c&scoped=true&"
import script from "./CardCompareCurrentB2X.vue?vue&type=script&lang=js&"
export * from "./CardCompareCurrentB2X.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1444034c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard,VCardTitle})
